// The Vue build version 至 load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { setupI18n, normalizeLocale } from './i18n'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
Vue.config.productionTip = false
Vue.use(ElementUI);
setupI18n(Vue)

let apiBase = process.env.API_BASE_URL || ''
axios.defaults.baseURL = apiBase;
Vue.prototype.domain = apiBase;
Vue.prototype.appBaseUrl = process.env.AUTO_BASE_URL || '';
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
/* eslint-disable no-new */
Vue.prototype.axios = axios
axios.defaults.withCredentials = true;
axios.defaults.headers.common['Authorization'] = localStorage.getItem('token') || '';
axios.interceptors.request.use((config) => {
  let locale = normalizeLocale('zh-cn')
  if (!config.headers) {
    config.headers = {}
  }
  config.headers['think-lang'] = locale
  if (!config.params) {
    config.params = {}
  }
  if (typeof config.params.lang == 'undefined') {
    config.params.lang = locale
  }
  if (!config.data) {
    config.data = {}
  }
  if (typeof config.data.lang == 'undefined') {
    config.data.lang = locale
  }
  return config
}, (error) => Promise.reject(error))
axios.interceptors.response.use((response) => {
  if (response.data.code == 401) {
    localStorage.removeItem('token')
    // window.location = '/#/login/login'
    location.reload()
  }
  // 对响应数据做点什么
  return response;
}, function(error) {
  // 对响应错误做点什么
  return Promise.reject(error);
});
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js